import {OrderPaymentDetailState} from '../interfaces'

export const getInitialState = (): OrderPaymentDetailState => ({
    summary: {
        type: 'NORMAL',
        amount: 0,
    },
    paymentDetail: {
        title: '',
        amount: 0,
        items: [],
    },
    paymentMethodDetail: {
        items: [],
    },
})
